import React, { useState } from 'react';
import AddReelModal from './AddReelModal';
import ReelList from './ReelList'; // Import the new ReelList component
import { ToastContainer } from 'react-toastify';

const ReelsManager = () => {
  const [reels, setReels] = useState([
    {
      id: 1,
      videoUrl: 'https://example.com/reel1.mp4',
      title: 'Summer Fragrance',
      isActive: true,
      order: 1,
    },
    {
      id: 2,
      videoUrl: 'https://example.com/reel2.mp4',
      title: 'Behind the Scenes',
      isActive: true,
      order: 2,
    },
    {
      id: 3,
      videoUrl: 'https://example.com/reel3.mp4',
      title: 'Customer Reviews',
      isActive: false,
      order: 3,
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAddReel = (newReel) => {
    setReels([...reels, { ...newReel, id: Date.now(), order: reels.length + 1 }]);
    setIsModalOpen(false); // Close the modal after adding
  };

  const handleToggleActive = (id) => {
    setReels(
      reels.map((reel) =>
        reel.id === id ? { ...reel, isActive: !reel.isActive } : reel
      )
    );
  };

  const handleDeleteReel = (id) => {
    setReels(reels.filter((reel) => reel.id !== id));
  };

  const moveReel = (id, direction) => {
    const index = reels.findIndex((reel) => reel.id === id);
    const newOrder = [...reels];

    if (direction === 'up' && index > 0) {
      [newOrder[index], newOrder[index - 1]] = [newOrder[index - 1], newOrder[index]];
    } else if (direction === 'down' && index < newOrder.length - 1) {
      [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
    }

    setReels(newOrder);
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Manage Reels Section</h2>
      <ToastContainer position="top-center" theme="colored" />

      {/* Add New Reel Button */}
      <div className="flex justify-end mb-6">
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
        >
          Add New Reel
        </button>
      </div>

      {/* Current Reels */}
      <ReelList
        reels={reels}
        onToggleActive={handleToggleActive}
        onDeleteReel={handleDeleteReel}
        onMoveReel={moveReel}
      />

      {/* Modal for Adding New Reel */}
      {isModalOpen && (
        <AddReelModal
          onClose={() => setIsModalOpen(false)}
          onAdd={handleAddReel}
        />
      )}
    </div>
  );
};

export default ReelsManager;